/* eslint-disable no-fallthrough */
import React, { useEffect, useRef, useState } from 'react';
import { useParams, useSearchParams, useNavigate } from "react-router";
import { InputGroup, FormControl, Container, Button, Dropdown, Tabs, Form, Col, Row, Table, SplitButton, ButtonGroup, DropdownButton, ToastContainer, Spinner } from 'react-bootstrap';


import { ArticleService } from '../../../services/ArticleService';
import { EditionService } from '../../../services/EditionService';

import DynamicTable from '../../../components/table/dynamic-table/DynamicTable';
import Pagination from '../../../components/pagination/Pagination';
import SideDetails from '../../../components/side-details/SideDetails';
import ClientDetails from '../../../components/side-details/client/client-details/ClientDetails';
import ClientEdition from '../../../components/side-details/client/client-edition/ClientEdition';
import ColManager from '../../../components/table/dynamic-table/col-manager/ColManager';
import Families from '../../../components/families/Families';
import { PreferenceService } from '../../../services/PreferenceService';
import ConfirmDialog from '../../../components/confirm-dialog/ConfirmDialog';
import ErrorManager from "../../../components/error-manager/ErrorManager";
import { GlobalContext } from "../../../services/GlobalProvider";
import { formatTableHeadersFromPrefs, granted, getFile } from '../../../helper/Helper'


const AnalysesTpl = (props) => {

    const { globalContextLoaded, preferences, parametres, folderDetails, grants, getPreferences } = React.useContext(GlobalContext);
    const data = props?.data?.data

    return (
        <Row>
            <Col>
                {data &&
                    <>
                        {data?.details?.map((detail, i) => (
                            <div key={i}>
                                {detail?.statuts.map((statut, j) => (
                                    <div key={j}>
                                        <h6>{statut?.total?.titre} ({statut?.total['Nombre']})</h6>
                                        {statut?.factures?.length > 0 &&
                                            <Table size="sm" className="mb-5">
                                                <thead>
                                                    <tr>
                                                        <th className="text-uppercase small text-gray-500">Client</th>
                                                        <th className="text-uppercase small text-gray-500">Facture</th>
                                                        <th className="text-uppercase small text-gray-500">Dat. Fact</th>
                                                        <th className="text-end text-uppercase small text-gray-500">Brut HT</th>
                                                        <th className="text-end text-uppercase small text-gray-500">Remise</th>
                                                        <th className="text-end text-uppercase small text-gray-500">Taxes</th>
                                                        <th className="text-end text-uppercase small text-gray-500">Tot. TTC</th>
                                                        <th className="text-uppercase small text-gray-500">Règlement</th>
                                                        <th className="text-end text-uppercase small text-gray-500">Marge</th>
                                                    </tr>
                                                </thead>

                                                <tbody>
                                                    {statut?.factures?.map((facture, k) => (
                                                        <tr key={k}>
                                                            <td style={{ maxWidth: "450px" }} className="text-break">{facture['Client']}</td>
                                                            <td className="">{facture['Facture']}</td>
                                                            <td className="">{facture['Date']}</td>
                                                            <td className="text-end">{facture['Brut HT']}</td>
                                                            <td className="text-end">{facture['Remise']}</td>
                                                            <td className="text-end">{facture['Taxe']}</td>
                                                            <td className="text-end">{facture['TTC']}</td>
                                                            <td className="">{facture['Reglement']}</td>
                                                            <td className="text-end">{facture['Marge']}</td>
                                                        </tr>
                                                    ))}
                                                    <tr className="fw-bold">
                                                        <td className="bg-primary-100">{statut.total['titre']}</td>
                                                        <td className="bg-primary-100"></td>
                                                        <td className="bg-primary-100"></td>
                                                        <td className="bg-primary-100 text-end">{statut.total['Total brut HT']}</td>
                                                        <td className="bg-primary-100 text-end">{statut.total['Total remise']}</td>
                                                        <td className="bg-primary-100 text-end">{statut.total['Total taxe']}</td>
                                                        <td className="bg-primary-100 text-end">{statut.total['Total TTC']}</td>
                                                        <td className="bg-primary-100 text-end"></td>
                                                        <td className="bg-primary-100 text-end"></td>
                                                    </tr>
                                                </tbody>
                                            </Table >
                                        }

                                    </div>
                                ))}
                            </div>
                        ))}

                        {data?.details.length > 0 &&
                            <Table size="sm" className="mb-5">
                                <thead>
                                    <tr>
                                        <th className="text-uppercase small text-gray-500">Récapitulatif</th>
                                        <th className="text-uppercase small text-gray-500 text-end">Brut HT</th>
                                        <th className="text-uppercase small text-gray-500 text-end">Remises</th>
                                        <th className="text-uppercase small text-gray-500 text-end">Net HT</th>
                                        <th className="text-uppercase small text-gray-500 text-end">Taxes</th>
                                        <th className="text-uppercase small text-gray-500 text-end">Net TTC</th>
                                        <th className="text-uppercase small text-gray-500 text-end">Marge (min, max)</th>
                                        <th className="text-uppercase small text-gray-500 text-end">Nombre</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {data?.recapitulatif?.map((recap, i) => (
                                        <tr key={i}>
                                            {recap['titre'] !== undefined && <td className="fw-bold">{recap['titre']}</td>}
                                            {recap['Titre'] !== undefined && <td className="fw-bold">{recap['Titre']}</td>}
                                            <td className="text-end fw-bold">{recap['Total brut HT']}</td>
                                            <td className="text-end fw-bold">{recap['Total remise']}</td>
                                            <td className="text-end fw-bold">{recap['Total net HT']}</td>
                                            <td className="text-end fw-bold">{recap['Total taxe']}</td>
                                            <td className="text-end fw-bold">{recap['Total TTC']}</td>
                                            <td className="text-end fw-bold">
                                                <span>{recap['Marge min']},</span>
                                                <span className="text-end">{recap['Marge max']}</span>
                                            </td>
                                            <td className="text-end fw-bold">{recap['Nombre']}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </Table>
                        }

                        {data?.resume?.map((res, i) => (
                            <div className="bg-primary-100 p-3 border rounded mb-3" key={i}>
                                {res['Nombre de Factures'] !== undefined && <p className="m-0">Nombre de Factures : {res['Nombre de Factures']}</p>}
                                {res['Moyenne Net HT par Factures'] !== undefined && <p className="m-0">Moyenne Net HT par Factures : {res['Moyenne Net HT par Factures']}</p>}
                                {res['Nombre de lignes'] !== undefined && <p className="m-0">Nombre de lignes : {res['Nombre de lignes']}</p>}
                                {res['Moyenne par ligne'] !== undefined && <p className="m-0">Moyenne par ligne : {res['Moyenne par ligne']}</p>}
                            </div>
                        ))}

                    </>
                }
                {(data?.details.length === 0 && data?.recapitulatif.length === 0 && data?.resume.length === 0) &&
                    <em>- Aucun résultat -</em>
                }
            </Col>
        </Row >
    )
}

export default AnalysesTpl;